import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { FormBuilder, FormGroup, Validators,FormControl } from "@angular/forms";
import { DatePipe } from '@angular/common';
import { CommonProjectDataService } from "../../_services/common-project-data.service";


export interface DialogData{
  orderId:string
}

@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
  styleUrls: ['./add-task.component.css'],
  providers: [DatePipe]
})
export class AddTaskComponent implements OnInit {
  public taskForm: FormGroup;
  public loading = false;
  public isVisbleToClient = false;
  public Options: any = {};
  public staffList: Array<any> = [];
  public clientList: Array<any> = [];
  public taskOption: any = {};
  private taskCount:number;
  public userDetails: any = {};

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private datepipe:DatePipe,
    private CommonProjectDataService: CommonProjectDataService
    ) {
      this.taskForm = this.formBuilder.group({
        task: [null, Validators.required],
        createDate: [null, Validators.required],
        //clientName: [null],
        staffName: [null]
      });

      this.CommonProjectDataService.taskCount.subscribe(tcount => {
        this.taskCount = tcount
      })
     }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.getStaffList();
    this.getClientList();
  }

  
  isFieldValid(field: string) {
    return (
      !this.taskForm.get(field).valid &&
      this.taskForm.get(field).touched && !this.taskForm.get(field).errors.min
    );
  }

  getStaffList = function () {
    let ppOptions = {
      id: localStorage.getItem("userID")
    };
    this.CommonService.apiService(
      "POST",
      "staff/list",
      ppOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.staffList = response.data.records;
          }

        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getClientList = function () {
    this.Options = {
      id: localStorage.getItem("userID"),
      search: ''
    };

    this.CommonService.apiService(
      "POST",
      "users/list",
      this.Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.clientList = response.data.records;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  
  createTask = function (postData) {
    if (this.taskForm.valid) {
      this.taskOption = {
        id: localStorage.getItem("userID"),
        title: postData.task,
        assign_date: this.datepipe.transform(new Date(postData.createDate), 'yyyy-MM-dd'),
        is_visible_to_client: this.isVisbleToClient,
        invoice_id: this.data.orderId        
      };

      // if (postData.clientName != null && postData.clientName != '') {
      //   this.taskOption.client_id = postData.clientName
      // }
      if (postData.staffName != null && postData.staffName != '') {
        this.taskOption.staff_ids = postData.staffName == "All" ? this.staffList.map(t => t.user_id) : postData.staffName;
      }

      this.CommonService.apiService(
        "POST",
        "task/create",
        this.taskOption
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            this.CommonProjectDataService.taskCount.next(this.taskCount + 1);
            this.userDetails.task_count = this.taskCount;
            localStorage.setItem("userDetails", JSON.stringify(this.userDetails));
            this.isVisbleToClient = false;
            this.taskForm.reset();
            // this._flashMessagesService.show(response.message, {
            //   cssClass: "alert-success",
            //   timeout: 5000
            // });
            this.dialogRef.close('success');            
          }

          window.scrollTo(0, 0);
        },
        err => {
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      );
    } else {
      this.validateAllFormFields(this.taskForm);
    }
  };

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/add-task/add-task.component.ts